import { UsersImportReport } from 'app/library/shared/async-job-drawer/models/user-import-report.model';

export class FetchUsersReportDetailsSuccess {
    static readonly type = '[User] FetchUsersReportDetailsSuccess';

    constructor(public payload: UsersImportReport) {}
}
